export function Page404() {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100vh',
				fontFamily: 'sans-serif',
			}}
		>
			<h1>404</h1>
			<p>Page not found.</p>
			<a href="/" style={{ color: '#007bff', textDecoration: 'underline' }}>
				Go Home
			</a>
		</div>
	);
}
